import React, { useMemo } from 'react';
import styled from 'styled-components';

import CitationBadge from './CitationBadge';
import { SummaryAttachment } from './types';

type Props = {
  title: string;
  attachments: SummaryAttachment[];
} & React.PropsWithChildren;

export default function Section({ title, attachments, children }: Props) {
  const sortedAttachments = useMemo(() => [...attachments].sort((a, b) => a.displayId - b.displayId), [attachments]);

  return (
    <Container>
      <HeaderContainer>
        <HeaderText>{title}</HeaderText>
        <CitationsContainer>
          {sortedAttachments.map((attachment) => (
            <CitationBadge key={attachment.attachmentId} size={14} attachment={attachment} />
          ))}
        </CitationsContainer>
      </HeaderContainer>
      <ContentContainer>{children}</ContentContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.black03};
  border-radius: 8px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  padding-bottom: 0;
`;

const HeaderText = styled.h2`
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  margin: 0;
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.black};
`;

const CitationsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

const ContentContainer = styled.div`
  padding: 0 50px 24px;
`;
